import { render } from "./CustomerAdminShipmentDashboard.vue?vue&type=template&id=f68abd10&scoped=true"
import script from "./CustomerAdminShipmentDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerAdminShipmentDashboard.vue?vue&type=script&lang=js"

import "./CustomerAdminShipmentDashboard.vue?vue&type=style&index=0&id=f68abd10&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f68abd10"]])

export default __exports__